import { useEffect, useState } from 'react';
import { assets, type Asset } from '../api';

export function AssetPicker({
  kind, onClose, onPick,
}: {
  kind: 'image' | 'video' | 'pdf';
  onClose: () => void;
  onPick: (asset: Asset) => void;
}) {
  const [list, setList] = useState<Asset[]>([]);
  const [search, setSearch] = useState('');

  useEffect(() => { assets.list(kind).then((r) => setList(r.assets)); }, [kind]);

  const visible = list.filter((a) => !search || a.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}
        style={{ width: 'min(800px, 90vw)', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <h2 style={{ marginTop: 0 }}>Pick {kind}</h2>
        <input placeholder="Search…" value={search} onChange={(e) => setSearch(e.target.value)}
          style={{ marginBottom: '0.8em' }} />
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {visible.length === 0 ? (
            <div className="empty">No {kind}s in the library. Upload some on the Assets page first.</div>
          ) : (
            <div style={{
              display: 'grid', gap: '0.6em',
              gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
            }}>
              {visible.map((a) => (
                <div key={a.id} onClick={() => { onPick(a); onClose(); }}
                  style={{
                    cursor: 'pointer', padding: '0.5em',
                    border: '1px solid var(--border)', borderRadius: 4,
                  }}>
                  <div style={{
                    height: 90, background: 'var(--bg-2)', borderRadius: 3,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
                  }}>
                    {a.kind === 'image' ? (
                      <img src={assets.rawUrl(a.id)} alt={a.name}
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                      <div style={{ color: 'var(--fg-3)', fontSize: '1.4em' }}>
                        {a.kind === 'video' ? '▶' : '📄'}
                      </div>
                    )}
                  </div>
                  <div style={{
                    marginTop: '0.4em', fontSize: '0.82em',
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                  }} title={a.name}>
                    {a.name}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.8em' }}>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
